import Unauthorized from './GenericError'

export default Unauthorized
